import { Drawer, DrawerContent, DrawerOverlay } from '@chakra-ui/react'
import { useStore } from '@contexts/store'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
const Cart = dynamic(() => import('@components/cart/cart'))
const OrderDetails = dynamic(() => import('@components/order/order-drawer'))
const CategoriesDrawer = dynamic(
  () => import('@components/categories/categories-drawer'),
)
const AdvancedFilters = dynamic(
  () => import('@components/advanced-filters'),
)

const ManagedDrawer = () => {
  const { displayDrawer, closeDrawer, drawerView, drawerOptions } = useStore()
  const { locale } = useRouter()
  const dir = locale === 'ar' ? 'rtl' : 'ltr'

  return (
    <Drawer
      isOpen={displayDrawer}
      placement={dir === 'rtl' ? 'left' : 'right'}
      onClose={closeDrawer}
      size={'md'}
      {...drawerOptions}
    >
      <DrawerOverlay />
      <DrawerContent>
        {/* <DrawerCloseButton /> */}
        {drawerView === 'CART_SIDEBAR' && <Cart />}
        {drawerView === 'ORDER_DETAILS' && <OrderDetails />}
        {drawerView === 'CATEGORIES_DRAWER' && <CategoriesDrawer />}
        {drawerView === 'ADVANCED_FILTERS_DRAWER' && <AdvancedFilters />}
      </DrawerContent>
    </Drawer>
  )
}

export default ManagedDrawer
